import React from "react";

import { useMediaQuery } from "react-responsive";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { FiChevronDown } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { filterActions } from "../store/filter";
import { useSelector } from "react-redux";

function Filter({ filterList }) {
  const isTabLandOrMore = useMediaQuery({
    query: "(min-width: 56.26em)",
  });
  const isPhonePortOrMinor = useMediaQuery({
    query: "(max-width: 56.25em)",
  });
  const touched = useSelector((state) => state.filter.touched);
  const dispatch = useDispatch();

  const clickFilterHandler = (e) => {
    const region = e.target.innerText;
    dispatch(
      filterActions.filterSelected({ method: "selected", value: region })
    );
  };

  const clearFilterHandler = () => {
    dispatch(filterActions.filterSelected({ method: "clear" }));
  };

  return (
    <div className="mt-12">
      <h1 className="text-primary text-center font-bold mb-10 text-2xl tab-port:text-left tab-port:pl-28">
        Filtros
      </h1>
      {touched && (
        <div className="text-center mb-10">
          <button
            className="text-2xl tab-port:text-xl font-medium border-2 px-5 py-4 rounded-md border-[#000000]"
            onClick={clearFilterHandler}
          >
            Limpiar Filtros X
          </button>
        </div>
      )}
      <div className="pb-4">
        {isTabLandOrMore && (
          <div>
            <div className="pl-28 text-[#ACACAC] mb-4 pb-4 border-b-2 text-2xl">
              Regiones
            </div>
            <ul>
              {filterList.map((value, index) => {
                return (
                  <li
                    key={value.code}
                    onClick={clickFilterHandler}
                    className="pl-28 text-2xl tab-port:hover:border-r-[3px] hover:bg-[#eef5ff] py-6 border-[#003670]"
                  >
                    {value.name}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      {isPhonePortOrMinor && (
        <div>
          <Accordion>
            <AccordionSummary
              expandIcon={<FiChevronDown />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <h1 className="text-xl">Regiones</h1>
            </AccordionSummary>
            <AccordionDetails>
              <ul className="text-center">
                {filterList.map((val) => {
                  return (
                    <li
                      key={val.code}
                      className="text-2xl hover:border-r-[3px] pt-6 border-[#003670]"
                      onClick={clickFilterHandler}
                    >
                      {val.name}
                    </li>
                  );
                })}
              </ul>
            </AccordionDetails>
          </Accordion>
        </div>
      )}

      {/* <button className="bg-[#003670] px-10 py-10 rounded-xl font-bold text-white">
        Eliminar Filtros
      </button> */}
    </div>
  );
}

export default Filter;
